/* eslint-env jest */
import groupByCategory from './giftCategory';

// Shaped like what Api::AddonResource serves: the section is resolved server-side
// (Addon#gift_category) and arrives on the add-on.
const addon = (name, giftCategory, giftCategoryLabel, giftCategoryPosition) => ({
  name, giftCategory, giftCategoryLabel, giftCategoryPosition,
});

const announcement = (name) => addon(name, 'announcements', 'Graduation Announcements', 0);
const magnet = (name) => addon(name, 'magnets', 'Magnets', 1);
const gift = (name) => addon(name, 'gifts', 'Photo Gifts', 2);
const print = (name) => addon(name, 'prints', 'Extra Prints', 3);

describe('groupByCategory', () => {
  it('orders sections by the position the server sent, not by arrival order', () => {
    const grouped = groupByCategory([
      print('Wallets'), announcement('Plaid'), gift('Coffee Cup'), magnet('Photo Magnets'),
    ]);

    expect(grouped.map((s) => s.title)).toEqual([
      'Graduation Announcements', 'Magnets', 'Photo Gifts', 'Extra Prints',
    ]);
  });

  it('collects every product of a section under one heading', () => {
    const grouped = groupByCategory([
      announcement('Plaid'), gift('Coffee Cup'), announcement('Cursive'),
    ]);

    expect(grouped).toHaveLength(2);
    expect(grouped[0].addons.map((a) => a.name)).toEqual(['Plaid', 'Cursive']);
    expect(grouped[1].addons.map((a) => a.name)).toEqual(['Coffee Cup']);
  });

  it('preserves the incoming order within a section', () => {
    const grouped = groupByCategory([print('Wallets'), print('5x7s'), print('3x5s')]);

    expect(grouped[0].addons.map((a) => a.name)).toEqual(['Wallets', '5x7s', '3x5s']);
  });

  // An elementary customer has no announcements at all (giftAddonVisible drops
  // them upstream), and an empty "Graduation Announcements" heading would
  // advertise a product they cannot buy.
  it('omits a section nothing falls into', () => {
    const grouped = groupByCategory([gift('Coffee Cup'), magnet('Photo Magnets')]);

    expect(grouped.map((s) => s.key)).toEqual(['magnets', 'gifts']);
  });

  it('carries the section blurb, and tolerates a section that has none', () => {
    const [gifts] = groupByCategory([gift('Coffee Cup')]);
    expect(gifts.blurb).toMatch(/every day/);

    const [unknown] = groupByCategory([addon('Mystery', 'brandnew', 'Brand New', 9)]);
    expect(unknown.blurb).toBeNull();
    expect(unknown.title).toBe('Brand New');
  });

  // A product flagged onto a sales page must never vanish because its category
  // did not come through -- e.g. a browser still holding a bundle from before
  // these attributes were served. Mis-filed and buyable beats invisible.
  it('keeps an uncategorised product visible, last, rather than dropping it', () => {
    const grouped = groupByCategory([
      { name: 'Stale Bundle Product' }, announcement('Plaid'),
    ]);

    expect(grouped.map((s) => s.title)).toEqual(['Graduation Announcements', 'More to Add']);
    expect(grouped[1].addons.map((a) => a.name)).toEqual(['Stale Bundle Product']);
  });

  it('returns nothing for an empty list instead of a page of empty headings', () => {
    expect(groupByCategory([])).toEqual([]);
    expect(groupByCategory()).toEqual([]);
  });
});
